/*
 ** vue router: Task
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtTask: RouteRecordRaw = {
  path: '/eservices/task',
  name: 'vrtTask',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'mytask',
      name: 'vrtTaskMyTask',
      component: () => import('./vpgTaskMyTask.vue'),
    },
    {
      path: 'vo',
      name: 'vrtTaskVO',
      component: () => import('./vpgTaskVO.vue'),
    },
    {
      path: 'ao',
      name: 'vrtTaskAO',
      component: () => import('./vpgTaskAO.vue'),
    },
    {
      path: 'admintasktest',
      name: 'vrtAdminTaskTest',
      component: () => import('./vpgAdminTaskTest.vue'),
    },
    {
      path: 'admintaskcrud',
      name: 'vrtAdminTaskCRUD',
      component: () => import('./vpgAdminTaskCRUD.vue'),
    },
  ],
};

export default vrtTask;
